import React from 'react';
import statusConverter from 'utils/statusConverter';

export const columnSetter = () => {
  const columns = [
    {
      Header: '상태정보',
      columns: [
        {
          Header: 'No',
          accessor: 'rnum',
        },
        {
          id: 'status',
          Header: () => <div>상태</div>,
          Cell: ({ row }) => statusConverter(row.original.status, 0),
        },
      ],
    },
    {
      Header: '장치정보',
      columns: [
        {
          Header: '장치번호',
          accessor: 'modelNo',
        },
        {
          Header: '장치명',
          accessor: 'modelNm',
        },
        {
          Header: '장치종류',
          accessor: 'moduleScn',
        },
      ],
    },
    {
      Header: '지역정보',
      columns: [
        {
          Header: '지역명',
          accessor: 'areaNm',
        },
      ],
    },
    {
      Header: '유저정보',
      columns: [
        {
          Header: '관리감독자(사용자)',
          accessor: 'userNm',
        },
        {
          Header: '전화번호',
          accessor: 'userPhone',
        },
      ],
    },
    {
      Header: '상태정보',
      columns: [
        {
          Header: '처리여부',
          accessor: 'resolveStatus',
        },
        {
          Header: '발생시각',
          accessor: 'regTime',
        },
      ],
    },
  ];

  return columns;
};
